//dependencias
import React, { Component } from 'react';

//componentes
import Proveedores from './proveedores';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <Proveedores /> 
            </div>
        );
    }
}
export default Index;